








































































import Component from 'vue-class-component';
import Vue from 'vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import { VModel } from 'vue-property-decorator';
import TextField from '@/general/component/TextField.vue';
import DatePicker from '@/general/component/form/input/DatePicker.vue';
import { CalculationRequestFormModel } from '@/context/calculation/model/CalculationRequestFormModel';
import SensorAutocomplete from '@/general/component/form/autocomplete/SensorAutcomplete.vue';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import { notNullOrUndefined } from '@/utility/functions';

@Component({
  components: {
    SensorAutocomplete,
    CustomerAutocomplete,
    DatePicker,
    DataLoggerAutocomplete,
    FacilityAutocomplete,
    TextInput,
    TextField
  }
})
export default class CalculationRequestFormTemplate extends Vue {
  @VModel({ type: Object }) model!: CalculationRequestFormModel;
  valid = true;

  get facilitiesQP() {
    if (notNullOrUndefined(this.model.customer)) {
      return `client=${this.model.customer}`;
    }
    return "";
  }
  get sensorQP() {
    if (notNullOrUndefined(this.model.customer)) {
      return `client=${this.model.customer}`;
    }
    return "";
  }
  get rules(): Record<string, unknown> {
    return {};
  }
}
